// Shared tus-js-client setup for presentation uploads (create flow +
// detail-page retry flow). Both consume the same Cloudflare Stream
// direct-upload URL contract.

import * as tus from "tus-js-client";

const CHUNK_SIZE_BYTES = 50 * 1024 * 1024; // 50 MiB; CF requires >= 5 MiB.
const RETRY_DELAYS_MS = [0, 1000, 3000, 5000];

export function tusUpload({ file, uploadURL, onError, onProgress, onSuccess }) {
  // uploadUrl only: server already reserved the tus session, browser
  // does HEAD + PATCH. Setting `endpoint` here triggers POST on the
  // reservation URL, which CF rejects.
  const upload = new tus.Upload(file, {
    uploadUrl: uploadURL,
    retryDelays: RETRY_DELAYS_MS,
    chunkSize: CHUNK_SIZE_BYTES,
    onError,
    onProgress,
    onSuccess,
  });

  upload.start();

  return upload;
}

// throttleByIntegerPercent wraps a tus onProgress callback so the
// underlying handler only fires when the integer percentage changes.
// Tus emits progress at ~20 Hz which makes width transitions stutter
// on hi-DPI; floor()-then-dedupe gives a smooth, cheap update path.
export function throttleByIntegerPercent(handler) {
  let last = -1;

  return (uploaded, total) => {
    const pct = total > 0 ? Math.floor((uploaded / total) * 100) : 0;
    if (pct === last) return;
    last = pct;
    handler(uploaded, total, pct);
  };
}

export function formatBytes(bytes) {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  if (bytes < 1024 * 1024 * 1024)
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} GB`;
}
